import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";

import InvoiceForm from "./InvoiceForm";
import InvoiceView from "./InvoiceView";
import InvoicePrint from "./InvoicePrint";
import { useCombinedContext } from "../../context/CombinedContext";
import exportToExcel from "../Excel/ExportToExcel";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const InvoiceList = () => {
  const [invoice, setInvoice] = useState([]);
  const [vessel, setVessel] = useState([]);

  const [filterData, setFilterData] = useState([]);
  const [fromDate, setFromDate] = useState(""); // Start date for filtering
  const [toDate, setToDate] = useState(""); // End date for filtering
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [isViewMode, setIsViewMode] = useState(false);
  const [selectedYear, setSelectedYear] = useState(""); // For year-wise filtering
  const [loading, setLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const { selectesVessel, selectedCompany } = useCombinedContext();
  const companyId = selectedCompany?._id;
  const companyCode = selectedCompany?.company_code;

  // console.log("for gst",selectedCompany)
  // console.log(invoice, "Invoice data  for excel");
  //  console.log("companyId: ", companyId);
  // console.log("vessel", vessel)

  const fetchInvoice = async () => {
    try {
      setLoading(true);
      setTimeout(() => {}, 100000);
      const params = {};
      if (fromDate) params.start_date = fromDate;
      if (toDate) params.end_date = toDate;

      const response = await axiosInstance.get(`/invoice/report/${companyId}`, {
        params,
      });
      setInvoice(response.data.data || []);
      setFilterData(response.data.data || []);
      // console.log(response.data.data);
    } catch (error) {
      // console.error("Error fetching invoice:", error);
      toast.error("Error fetching invoice");
    } finally {
      setLoading(false);
    }
  };
  const fetchVessel = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/vessel/company/${companyId}`);
      setVessel(response.data.vessels || []);
      // console.log("Vessel", response);
      // console.log("companyId: ", companyId);
    } catch (error) {
      // console.error("Error fetching invoice:", error);
      toast.error("Error fetching Vessel");
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if(companyId){
  //     fetchInvoice();
  //   }
  // }, [companyId]);

  useEffect(() => {
    if (companyId) {
      fetchInvoice();
    }
  }, [companyId, fromDate, toDate]);

  const handleSearchChange = (e) => {
    const searchText = e.target.value.toLowerCase();
    const filteredLocation = invoice.filter(
      (invoice) =>
        invoice.invoice_no?.toString().toLowerCase().includes(searchText) ||
        invoice.company_name?.toString().toLowerCase().includes(searchText) ||
        invoice.invoice_status?.toString().toLowerCase().includes(searchText) ||
        invoice.company_code?.toString().toLowerCase().includes(searchText),
    );
    setFilterData(filteredLocation);
  };

  const deleteCompany = async (_id) => {
    try {
      await axiosInstance.delete(`/invoice/${_id}`);
      fetchInvoice();
    } catch (error) {
      // console.error("Error deleting company:", error);
      toast.error("Failed to delete conpany");
    }
  };

  const handleDelete = (id) => {
    setDeleteTarget(id);
    setIsDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;
    try {
      await axiosInstance.delete(`/invoice/${deleteTarget}`);
      setInvoice((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setFilterData((prev) => prev.filter((loc) => loc._id !== deleteTarget));
      setIsDeleteModalOpen(false);
      setDeleteTarget(null);
      toast.success("Location deleted successfully");
    } catch (error) {
      // console.error("Error deleting location:", error);
      toast.error("Failed to delete location");
    }
  };

  // Get data from selected year
  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    if (year) {
      setFromDate(`${year}-01-01`);
      setToDate(`${year}-12-31`);
    } else {
      setFromDate("");
      setToDate("");
    }
  };

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };
  // const itemsPerPage = 5;
  const currentInvoiceItems = [...filterData]
    .reverse()
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const pageCount = Math.ceil(filterData.length / itemsPerPage);

  //Check Role

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;

  const handleExport = () => {
    const sheetData = [];
    const merges = [];

    // Define headers conditionally
    const headers = [
      "Sl No",
      "SSG Yard",
      "Company Name",
      "Company Code",
      "Invoice Date",
      "Invoice No",
      "Vessel Name",
      "Project Code",
      "Work Order No",
      "Invoice Status",
      "Bill Items",
      "",
      "",
      "",
      "",
      "Sub Total",
    ];

    if (["admin", "superadmin"].includes(userRole)) {
      headers.push("GST Amount", "Total Amount");
    }

    sheetData.push(headers);

    // Define sub-headers conditionally
    const subHeaders = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Job No (Bill Items)",
      "Description",
      "Unit Price",
      "Quantity",
      "Amount",
      "",
    ];

    if (["admin", "superadmin"].includes(userRole)) {
      subHeaders.push("", "");
    }

    sheetData.push(subHeaders);

    // Merge header cells for vertical fields
    merges.push(
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // Sl No
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // SSG Yard
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // Company Name
      { s: { r: 0, c: 3 }, e: { r: 1, c: 3 } }, // Company Code
      { s: { r: 0, c: 4 }, e: { r: 1, c: 4 } }, // Invoice Date
      { s: { r: 0, c: 5 }, e: { r: 1, c: 5 } }, // Invoice No
      { s: { r: 0, c: 6 }, e: { r: 1, c: 6 } }, // Vessel Name
      { s: { r: 0, c: 7 }, e: { r: 1, c: 7 } }, // Project Code
      { s: { r: 0, c: 8 }, e: { r: 1, c: 8 } }, // Work Order No
      { s: { r: 0, c: 9 }, e: { r: 1, c: 9 } }, // Invoice Status
      { s: { r: 0, c: 15 }, e: { r: 1, c: 15 } }, // Sub Total
    );

    if (["admin", "superadmin"].includes(userRole)) {
      merges.push(
        { s: { r: 0, c: 16 }, e: { r: 1, c: 16 } }, // GST Amount
        { s: { r: 0, c: 17 }, e: { r: 1, c: 17 } }, // Total Amount
      );
    }

    // Merge the "Bill Items" header across columns 11 to 15 in row 0
    merges.push({ s: { r: 0, c: 10 }, e: { r: 0, c: 14 } });

    // Process each invoice from filterData
    filterData.forEach((item, rowIndex) => {
      const startRow = sheetData.length;
      const invoiceDate = new Date(item.invoice_date).toLocaleDateString();

      item.bill.forEach((billItem, billIndex) => {
        const row = [
          rowIndex + 1 + billIndex,
          billIndex === 0 ? item.supplier?.yard_name || "" : "",
          billIndex === 0 ? item.company?.company_name || "" : "",
          billIndex === 0 ? item.company_code || "" : "",
          billIndex === 0 ? invoiceDate : "",
          billIndex === 0 ? item.invoice_no || "" : "",
          billIndex === 0 ? item.project_code?.vessel_name || "" : "",
          billIndex === 0 ? item.project_code?.project_code || "" : "",
          billIndex === 0 ? item.order_no || "" : "",
          billIndex === 0 ? item.invoice_status || "" : "",
          billItem.job_no,
          billItem.description,
          billItem.unit_price,
          billItem.quantity,
          billItem.amount,
          billIndex === 0 ? item.total_without_gst || "" : "",
        ];

        if (["admin", "superadmin"].includes(userRole)) {
          row.push(
            billIndex === 0 ? item.gst_amount || "" : "",
            billIndex === 0 ? item.total_with_gst || "" : "",
          );
        }

        sheetData.push(row);
      });

      const endRow = sheetData.length - 1;

      if (item.bill.length > 1) {
        const mergeColumns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 15];
        if (["admin", "superadmin"].includes(userRole)) {
          mergeColumns.push(16, 17);
        }

        mergeColumns.forEach((col) => {
          merges.push({ s: { r: startRow, c: col }, e: { r: endRow, c: col } });
        });
      }
    });

    // Convert data to worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    worksheet["!merges"] = merges;

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Write the workbook and trigger a download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(dataBlob, "exported_invoice_data.xlsx");
  };

  function formatPrice(price) {
    const num = parseFloat(price);
    if (isNaN(num)) return "N/A";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return (
    <div>
      <ToastContainer />
      <div className="mb-4 headStyle d-flex  justify-content-between align-items-center">
        {["admin", "superadmin"].includes(userRole) ? (
          <h4>Invoice</h4>
        ) : (
          <h4>Dia Inch Summary</h4>
        )}
        <button
          className="button-2"
          onClick={() => {
            if (selectedCompany?.status === false) {
              toast.error(
                "The selected company is inactive. Cannot add a invoice.",
              );
            } else {
              setSelectedData(null);
              setShowForm(true);
            }
          }}
          style={{
            borderRadius: "8px",
            whiteSpace: "nowrap",
            padding: "8px 16px",
          }}
        >
          Add Invoice
        </button>
      </div>
      <div className="headStyle">
        <div className="d-flex flex-wrap align-items-center gap-3">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <label
              htmlFor="fromDate"
              style={{ width: "-webkit-fill-available" }}
            >
              From Date
            </label>
            <input
              className="form-control"
              type="date"
              placeholder="From Date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <label
              htmlFor="fromDate"
              style={{ width: "-webkit-fill-available" }}
            >
              To Date
            </label>
            <input
              className="form-control"
              type="date"
              placeholder="To Date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div>
            <select
              className="form-select"
              value={selectedYear}
              onChange={handleYearChange}
              // size={30}
              style={{
                width: "70px", // Adjust the width
                maxHeight: "300px !importent", // Limit the height of the dropdown
                overflowY: "auto", // Add scroll for long lists
              }}
            >
              <option value="">Year</option>
              {Array.from(
                { length: new Date().getFullYear() - 2000 + 1 },
                (_, i) => 2000 + i,
              ).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="headStyle mt-4 ">
        <div className="d-flex mt-2 flex-wrap align-items-center gap-3 justify-content-between">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <div>
              <input
                className="form-control"
                type="search"
                placeholder="Search..."
                style={{
                  maxWidth: "100%",
                  border: "1px solid #1E2A5E",
                  borderRadius: "8px",
                }}
                onChange={handleSearchChange}
              />
            </div>
            <div className="d-flex align-items-center">
              <label className="me-2 pt-1">Count</label>
              <select
                className="form-select no-arrow"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                style={{ width: "auto" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
          <div style={{ flex: "0 1 auto" }}>
            <button className="button-2" onClick={handleExport}>
              Export to Excel
            </button>
          </div>
        </div>

        <div
          className="my-3 rounded table-responsive-sm"
          style={{
            overflowX: "auto",
          }}
        >
          <table
            id="my-table"
            className="table table-bordered mb-0"
            style={{
              width: "auto",
            }}
          >
            <thead className="t_head">
              <tr className="text-center align-middle">
                {/* Table Headers */}
                <th className="align-middle">Sl No</th>
                <th className="align-middle">SSG Yard</th>
                <th className="align-middle">Company Name</th>
                <th className="align-middle">Company Code</th>
                <th className="align-middle">Invoice Date</th>
                <th className="align-middle">Invoice No</th>
                <th className="align-middle">Job No</th>
                <th className="align-middle">Vessel Name</th>
                <th className="align-middle">Project Code</th>
                <th className="align-middle">Work Order No</th>
                <th className="align-middle">Invoice Status</th>
                <th className="align-middle">Total Amount Before Tax</th>

                {["admin", "superadmin"].includes(userRole) && (
                  <>
                    <th className="align-middle">GST Amount</th>
                    <th className="align-middle">Total Amount</th>
                  </>
                )}
                <th className="text-center align-middle ">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="15">
                    <div className="d-flex justify-content-center m-3">
                      <div className="spinner"></div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {currentInvoiceItems.length === 0 ? (
                    <>
                      <tr>
                        <td colSpan="15">
                          <div className="d-flex justify-content-center m-1">
                            <h6>Data Not Found</h6>
                          </div>
                        </td>
                      </tr>
                    </>
                  ) : (
                    <>
                      {currentInvoiceItems &&
                        currentInvoiceItems.map((invoice, index) => (
                          <tr key={invoice._id || index}>
                            {/* Table Data */}
                            <td>{currentPage * itemsPerPage + index + 1}</td>
                            <td>{invoice.supplier?.code || "N/A"}</td>
                            <td>{invoice.company?.company_name || "N/A"}</td>
                            <td>{invoice.company_code || "N/A"}</td>
                            <td>
                              {invoice.invoice_date
                                ? new Date(
                                    invoice.invoice_date,
                                  ).toLocaleDateString()
                                : "N/A"}
                            </td>
                            <td>{invoice.invoice_no || "N/A"}</td>
                            <td>{invoice.job_no || "N/A"}</td>
                            <td>
                              {invoice.project_code?.vessel_name || "N/A"}
                            </td>
                            <td>
                              {invoice.project_code?.project_code || "N/A"}
                            </td>
                            <td>{invoice.order_no || "N/A"}</td>
                            <td>{invoice.invoice_status || "N/A"}</td>
                            <td>
                              {`$ ${formatPrice(invoice.total_without_gst)}` ||
                                "N/A"}
                            </td>

                            {["admin", "superadmin"].includes(userRole) && (
                              <>
                                <td>
                                  {`$ ${formatPrice(invoice.gst_amount)}` ||
                                    "N/A"}
                                </td>
                                <td>
                                  {`$ ${formatPrice(invoice.total_with_gst)}` ||
                                    "N/A"}
                                </td>
                              </>
                            )}

                            <td>
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                {["admin", "superadmin"].includes(userRole) && (
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => {
                                      setSelectedData(invoice);
                                      setIsViewMode(true);
                                    }}
                                  >
                                    <i className="bi bi-folder2-open"></i>
                                  </button>
                                )}
                                <button
                                  className="btn btn-outline-success btn-sm"
                                  onClick={() => {
                                    setSelectedData(invoice);
                                    setShowForm(true);
                                  }}
                                >
                                  <i className="bi bi-pencil-square"></i>
                                </button>
                                {["admin", "superadmin"].includes(userRole) && (
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() => handleDelete(invoice._id)}
                                  >
                                    <i className="bi bi-trash3"></i>
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          containerClassName="pagination justify-content-center pagination-sm"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="active"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          disabledClassName="disabled"
        />
        {isViewMode && (
          <InvoiceView
            invoice={selectedData}
            isViewMode={isViewMode}
            userRole={userRole}
            setIsViewMode={setIsViewMode}
          />
        )}
        {showForm && (
          <InvoiceForm
            invoice={selectedData}
            companyCode={companyCode}
            companyId={companyId}
            vessel={vessel}
            selectedCompany={selectedCompany}
            onClose={() => {
              setShowForm(false);
              fetchInvoice();
            }}
          />
        )}
        {isDeleteModalOpen && (
          <div
            className={`modal fade ${isDeleteModalOpen ? "show d-block" : ""}`}
            style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="deleteModalLabel"
            aria-hidden={!isDeleteModalOpen}
            onClick={(e) => {
              if (e.target.classList.contains("modal"))
                setIsDeleteModalOpen(false);
            }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="deleteModalLabel">
                    Confirm Deletion
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setIsDeleteModalOpen(false)}
                  ></button>
                </div>
                <div className="modal-body modalWhite">
                  Are you sure you want to delete this location? This action
                  cannot be undone.
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setIsDeleteModalOpen(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={confirmDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InvoiceList;
